/**
 * YouTubeEmbed — Phase E split (May 6, 2026).
 *
 * Extracted from `LandingPage.jsx`. Behavior, classes, and the URL→video
 * id regex are byte-identical to the previous inline component.
 */

const getVideoId = (url) => {
  if (!url) return null;
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
};

const YouTubeEmbed = ({ url }) => {
  const videoId = getVideoId(url);
  if (!videoId) return null;

  return (
    <iframe
      className="w-full h-full rounded-xl"
      src={`https://www.youtube.com/embed/${videoId}`}
      title="EOC Closet Video"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  );
};

export default YouTubeEmbed;
